"use client";

import { useLocale } from "next-intl";
import { ThemeProvider } from "next-themes";
import { ReactNode } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ThirdwebProvider } from "thirdweb/react";

type Props = {
  children: ReactNode;
};

export function Providers({ children }: Readonly<Props>) {
  const locale = useLocale();

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
      language={locale}
    >
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <ThirdwebProvider>{children}</ThirdwebProvider>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}
